import { useLocation, useNavigate, useParams } from 'react-router-dom'
import FundIcon from 'assets/images/buySubscription/fund.svg'
import classNames from 'classnames'
import useSetPlan from './hooks/useSetPlan'
import Free from './descriptions/free'
import Fee from './descriptions/fee'
import Shared from './descriptions/shared'
import Header from 'components/headers/bulletins'
import { toggleSupportModal } from 'store/redux/sidebar'
import { useDispatch, useSelector } from 'react-redux'
import SupportModal from 'components/modals/supportModal'
import { RootState } from 'store/redux'

export default function BuySubscription() {
    const { plans, handleSelectPlan, selectedplan } = useSetPlan()
    const navigate = useNavigate()
    const { moneyPool } = useParams()
    const dispatch = useDispatch()
    const { isOpenSupportModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )
    return (
        <>
            <div className=" flex flex-col bg-[#F2F2F2]">
                <div className=" grow-0">
                    <Header title={`ارتقاء صندوق`} />
                </div>
                <div className=" grow px-2 ">
                    <div className=" px-10">
                        <p className=" text-center">
                            شما می توانید برای استفاده از امکانات همیان یکی از
                            سه نسخه‌ی‌‌ زیر را انتخاب کنید
                        </p>
                        <img
                            src={FundIcon}
                            alt="fund"
                            className=" mx-auto my-3"
                        />
                    </div>
                    <p className=" text-center mb-3">نسخه‌های صندوق پس‌انداز</p>
                    <div className="grid grid-cols-3 gap-2 px-2">
                        {plans.map((item) => (
                            <div
                                onClick={() => {
                                    if (!item.selected) {
                                        handleSelectPlan(item.id)
                                    }
                                }}
                                className={classNames(
                                    ' flex flex-col items-center justify-center px-4 py-6 rounded-lg',
                                    item.selected
                                        ? ' border-1  border-green-1 text-green-1 bg-plan-bg'
                                        : ' border-1  border-border-plan shadow-[0px_4px_16px_rgba(17,17,26,0.1),_0px_8px_24px_rgba(17,17,26,0.1),_0px_16px_56px_rgba(17,17,26,0.1)]'
                                )}
                            >
                                {item.icon && (
                                    <img
                                        src={
                                            item.selected
                                                ? item.selectedIcon
                                                : item.icon
                                        }
                                        alt="plan"
                                    />
                                )}
                                <p className=" my-2">{item.text}</p>
                            </div>
                        ))}
                    </div>
                    {selectedplan === 0 && <Free />}
                    {selectedplan === 1 && <Fee />}
                    {selectedplan === 2 && <Shared />}
                    <div className=" my-1 text-center">
                        <p>نیاز به راهنمایی دارید؟</p>
                        <p
                            className=" text-[#808080] underline-offset-8"
                            onClick={() =>
                                dispatch(
                                    toggleSupportModal({
                                        isOpenSupportModal: true,
                                    })
                                )
                            }
                        >
                            با مشاور همیان تماس بگیرید
                        </p>
                    </div>
                </div>
                {selectedplan !== 0 && (
                    <div className=" grow-0 mx-2">
                        <button
                            className=" w-full rounded-md bg-green-1 text-white mb-2 py-3"
                            onClick={() =>
                                navigate(
                                    selectedplan === 1
                                        ? `/fund/plans/commission/${moneyPool}`
                                        : `/fund/plans/subscription/${moneyPool}`
                                )
                            }
                        >
                            انتخاب
                        </button>
                    </div>
                )}
            </div>
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
        </>
    )
}
